import { SET_DEVICE_TO_CONNECT, SAVE_CONNECTIONS } from './constants';

export const setDeviceToConnect = device => ({ type: SET_DEVICE_TO_CONNECT, device });
export const saveConnections = (device, teamIds, geofenceIds) => ({ type: SAVE_CONNECTIONS, device, teamIds, geofenceIds });
